import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './listTable.css';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import App from './components/layout/App/App';
import GenericErrorFallback from './components/common/GenericErrorFallback/GenericErrorFallback';
import { store } from './redux/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary
        FallbackComponent={GenericErrorFallback}
        onReset={() => window.location.reload()}
      /* eslint-disable-next-line no-console */
        onError={(error) => console.log('error caught at boundary: ', error.message)}
        resetKeys={[window.location.pathname]}
      >
        <App />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById('react-root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
